import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const PromoSection = () => {
  const navigate = useNavigate();
  return <div className="bg-indigo-600 rounded-lg p-8 text-white flex flex-col md:flex-row items-center justify-between" data-id="element-343">
      <div className="mb-6 md:mb-0" data-id="element-344">
        <h2 className="text-2xl font-bold mb-2" data-id="element-345">Create Your Own AI App</h2>
        <p className="text-indigo-100 mb-6" data-id="element-346">
          Turn your prompts into powerful AI applications and share them with
          the world
        </p>
        <button onClick={() => navigate('/create')} className="bg-white text-indigo-600 px-4 py-2 rounded-md hover:bg-indigo-100 transition-colors flex items-center" data-id="element-347">
          Start Creating <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-348" />
        </button>
      </div>
      <div className="w-full md:w-1/3" data-id="element-349">
        <div className="bg-indigo-500/30 p-4 rounded-lg border border-indigo-400/30" data-id="element-350">
          <img src="https://cdn.pixabay.com/photo/2023/05/21/06/35/ai-generated-8007739_1280.png" alt="AI App Creation" className="w-full h-auto rounded" data-id="element-351" />
        </div>
      </div>
    </div>;
};